export enum FeatureFlag {
  SATELLITE_IMAGERY = 'SATELLITE_IMAGERY',
}
